<template>
	<TimelineEvent :event="event" class="noGoEvent" :simplified="simplified">
		<template #body>
			<div class="flex items-center overflow-hidden opacity-54"></div>
		</template>

		<template v-if="!endsInPast" #tooltipTitle
			><span class="text-active"><I18n path="bufferZone.name" /></span
		></template>

		<template v-if="!endsInPast" #tooltipBody>
			<div><I18n path="bufferZone.desc" /></div>
		</template>
	</TimelineEvent>
</template>

<script setup lang="ts">
import { I18n } from '@bluebrick/saas-ui'
import { computed, toRefs } from 'vue'
import { isInPastDateTime } from '@/common/dateUtils'
import TimelineEvent from '@/features/events/components/timeline/events/TimelineEvent.vue'
import type { EventDataWithStore } from '@/types'

const props = defineProps<{
	event: EventDataWithStore
	simplified?: boolean
}>()

const { event } = toRefs(props)

const endsInPast = computed(() => isInPastDateTime(event.value.end_date))
</script>

<style lang="scss" scoped>
.noGoEvent {
	background-image: url('@/assets/banned-zone.svg');
	background-color: theme('colors.level.01');
	background-repeat: repeat-x;
	border: none;
	cursor: default;
}
</style>
